export default __webpack_public_path__ + "static/media/Rectangle.e4accbe3.png";